import { useMutation, useQueryClient } from '@tanstack/react-query';
import { HTTPError } from 'ky';
import { ShopTypes } from '~/lib/data-contract';
import { BasketValidationError } from '~/lib/data-contract/auto-generated/shop-api-model';
import useBasketReference from '~/services/shop/hooks/selectors/basket/useBasketReference';
import { useUserId } from '~/shared/utils/cookie';
import { useBasketAddEmitter } from '~/shared/utils/events';
import { useBasketTimer } from '~/shared/utils/storage';
import { hideQuickAddToBasketModal } from '~/state/useQuickAddToBasketState';
import { addBasketItem } from '../../operations/basket';
import { openPowerStepModal } from '~/state/modalTransitions';

interface Arguments extends ShopTypes.BasketItemOptions {
    itemNo: string | undefined;
}

export default function useAddBasketItem(shouldOpenPowerStep?: boolean) {
    const queryClient = useQueryClient();
    const [userId] = useUserId();
    const { data: reference } = useBasketReference();
    const [, setTimer] = useBasketTimer();
    const emitAddBasketItemAnimation = useBasketAddEmitter();

    return useMutation<
        ShopTypes.BasketResponse,
        HTTPError | Error | BasketValidationError,
        Arguments
    >((props) => addBasketItem({ reference, userId, ...props }), {
        onSuccess: (data, values) => {
            emitAddBasketItemAnimation(String(values.itemNo));
            queryClient.setQueryData(['basket', { reference: data.basketReference }], data);
            setTimer(data.updated.toString());
            hideQuickAddToBasketModal();
            if (shouldOpenPowerStep) {
                openPowerStepModal(String(values.itemNo), values.warehouseId);
            }
        },
    });
}
